import { defineStore } from 'pinia'
import { request } from '../../api'

export const useUserSearchStore = defineStore('userSearch', {
  state: () => ({
    titles: [
      'Collections',
      'Designs',
      'Fit models',
      'Fit Charts',
    ],
    data: [],
    params: {
      limit: 100,
      q: '',
      sortDirection: 'asc',
      sortField: 'updatedAt',
    },

    loading: false,
  }),
  actions: {
    async setSortOrder (order) {
      this.params.sortDirection = order
      await this.getData()
    },
    async sort (sort) {
      this.params.sortField = sort
      await this.getData()
    },

    async getData () {
      this.loading = true
      try {
        const { data } = await request.get(
          '/user/search',
          { params: this.params },
        )
        this.data = data
        this.loading = false
      } catch (e) {
        console.error(e.message)
        this.loading = false
      }
    },
  },
})
